<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Input, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';
	import { callBluTRV, getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { TRVComponentConfig } from 'src/types/TRVComponent';
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';

	export let device: Device;

	const trvConfig: TRVComponentConfig = getTrvComponentByDevice(device)?.config;
	const min = -12.5;
	const max = 12.5;

	let waitForResponse = false;
	let offsetValue: any = trvConfig?.['temperature:0']?.offset_C || 0;
	$: inputData = getErrorOrInfoMessageForMinAndMax(offsetValue, min, max);

	const handleTempOffset = async () => {
		waitForResponse = true;
		await callBluTRV(device, 'Temperature.SetConfig', {
			id: 0,
			config: { offset_C: offsetValue },
		});
		waitForResponse = false;
	};
</script>

<Input
	aria-label={$format('input_temperature_offset', {
		default: 'Enter the temperature offset. Value must be between {min} — {max}!',
		values: { min, max },
	})}
	{...getNumberInputConfig(true)}
	class="mb-s"
	bind:value={offsetValue}
	info={inputData.info}
	error={inputData.error}
	id="input-8fccokw"
/>
<Button
	loading={waitForResponse}
	disabled={waitForResponse || inputData.error}
	class="mt-s"
	size="m"
	on:click={handleTempOffset}
	width="full"
	>{$format('button_save_settings', {
		default: 'Save settings',
	})}</Button
>
